import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useShowVersions } from '@atlassian/jira-software-view-settings';
import type { Card } from '../../../../model/types';
import {
	getLabelWidthMultiplier,
	LabelType,
} from '../../card/card-contents/utils/responsive-labels';
import { VersionsField } from '../../card/card-contents/versions-field';
import type { ScreenSize } from '../../hooks/common/constants';

type Props = {
	card: Card;
	isCompanyManaged: boolean;
	backlogContainerSize: ScreenSize | undefined;
	isCardListContainsVersion: boolean;
};

export const Versions = ({
	card,
	isCompanyManaged,
	backlogContainerSize,
	isCardListContainsVersion,
}: Props) => {
	const shouldDisplayVersions = isCompanyManaged && isCardListContainsVersion;

	const showVersions = useShowVersions();

	if (shouldDisplayVersions && showVersions) {
		return (
			<VersionsContainer
				widthMultiplier={getLabelWidthMultiplier(LabelType.VERSION, backlogContainerSize)}
			>
				<VersionsField cardId={card.id} backlogContainerSize={backlogContainerSize} />
			</VersionsContainer>
		);
	}
	return null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const VersionsContainer = styled.div<{ widthMultiplier: number }>({
	display: 'grid',
	zIndex: '1',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	alignItems: 'center',
	justifyItems: 'start',
	pointerEvents: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	gridTemplateColumns: ({ widthMultiplier }) =>
		`repeat(auto-fit, calc(${token('space.100', '8px')} * ${widthMultiplier}))`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	minWidth: ({ widthMultiplier }) => `calc(${token('space.100', '8px')} * ${widthMultiplier})`,
});
